/** Vesting package id for Explorer pool address claim UI. */

function viteEnv(key: string): string | undefined {
	const v = (import.meta as ImportMeta & { env?: Record<string, string> }).env?.[key];
	return typeof v === 'string' && v.trim() ? v.trim() : undefined;
}

function isPlaceholderPackageId(id: string): boolean {
	const hex = id.replace(/^0x/i, '').toLowerCase();
	return !hex || /^0+$/.test(hex);
}

/** Sync env (written by `cpc_write_explorer_env`). */
export function getVestingPackageIdFromEnv(): string | null {
	const id = viteEnv('VITE_CPC_VESTING_PACKAGE_ID');
	if (!id || isPlaceholderPackageId(id)) return null;
	return id;
}

/**
 * Resolve vesting package id: env first, then `/cpc-vesting-package-ids.json`
 * (deploy publishes from genesis ceremony yaml).
 */
export async function resolveVestingPackageId(): Promise<string | null> {
	const fromEnv = getVestingPackageIdFromEnv();
	if (fromEnv) return fromEnv;
	try {
		const res = await fetch('/cpc-vesting-package-ids.json', { cache: 'no-store' });
		if (!res.ok) return null;
		const doc = (await res.json()) as {
			cpc_vesting_package_id?: string;
			vesting_package_id?: string;
			packageId?: string;
		};
		const id =
			doc.cpc_vesting_package_id || doc.vesting_package_id || doc.packageId || '';
		if (!id || isPlaceholderPackageId(id)) return null;
		return id.trim();
	} catch {
		return null;
	}
}

export function linearWalletType(packageId: string, dgcType: string): string {
	return `${packageId}::linear::Wallet<${dgcType}>`;
}
